import Skill from './Skill.jsx';

export default Skill;
